// 添加埋点事件
class CustomEventGa extends HTMLElement {
    constructor() {
      super();
      this.handleEvent = this.handleEvent.bind(this);
      
      this.loginInit();
      this.socialClick();
    }
    shareToSocialMedia(platform, url, title,hashtags) {
      const socialMediaUrl = {
        facebook:
          'https://www.facebook.com/sharer/sharer.php?u=' +
          encodeURIComponent(url) +
          '&hashtag=' +
          encodeURIComponent(title),
        twitter:
          'https://twitter.com/intent/tweet?url=' +
          encodeURIComponent(url) +
          '&text=' +
          encodeURIComponent(title) +
          '&hashtags=' +
          encodeURIComponent(hashtags)
      }
    
      window.open(socialMediaUrl[platform], '_blank')
    }
    // 社媒分享点击
    socialClick(){
      const socialList = document.querySelectorAll('.public-social-contain .social-list .tm-item');
  
      socialList.forEach((item) => {
        
        item.addEventListener('click', (event) => {
          const type = event.target.getAttribute('data-type');
          switch (type) {
            case 'facebook':
               this.shareToSocialMedia("facebook", window.location.href, document.title,"Bluetti Global");
              break;
              case 'twitter':  
              this.shareToSocialMedia("twitter", window.location.href, document.title,"bluettipower");
              break;
            case 'ins':
            window.open("https://www.instagram.com/bluetti_official", '_blank');
              break; 
            case 'youtube':
            window.open("https://www.youtube.com/channel/UC__Tu8lHDpThTB2EIpfbJ7Q", '_blank');
              break;  
            default:
              break;
          }
          
         
        });
      });  
    }
  
  
    connectedCallback() {
      this.userRole = this.dataset.userRole;
      this.pageName = this.dataset.pageName;
      this.belongAreasEl = this.querySelectorAll('[data-belong-area]');
  
      this.init();
    }
    
    loginInit() {
      var goLoginList = this.querySelectorAll('.public-login-link');
      if (goLoginList.length == 0) return;
      goLoginList.forEach(function (item) {
        item.addEventListener('click', function (event) {
          var link = event.target.dataset.link;
          var loginEl = document.querySelector('.public-email-send-code');
          loginEl.style.display = 'flex';
          if (link) {
            loginEl.redirect = link;
          }
        });
      });
    }
  
  
    init() {
      document.addEventListener('click', (event) => {
        var target = event.target;
        var belongAreasEl = target.closest('[data-belong-area]');
        var eventHandlesEl = target.getAttribute('data-event');
        if (belongAreasEl && eventHandlesEl) {
          var belongAreaParam = belongAreasEl.dataset.belongArea || 'N/A';
          var parameters = target.dataset?.eventParameters;
          if (!parameters) return;
  
          try {
            var formatParameters = JSON.parse(parameters);
            this.handleEvent(eventHandlesEl, eventHandlesEl, {
              user_role: this.userRole,
              page_name: this.pageName,
              belong_area: belongAreaParam,
              ...formatParameters,
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
    }
  
    handleEvent(el, event = 'click', parameters) {
      // console.log('event', event, parameters);
      
      window.gtag('event', event, parameters);
    }
  }
  
  if (!customElements.get('custom-event')) {
    customElements.define('custom-event', CustomEventGa);
  }